export const FLOWDESIGNER_FLOW_LOAD = 'FLOWDESIGNER.FLOW_LOAD';
export const FLOWDESIGNER_FLOW_RESET = 'FLOWDESIGNER.FLOW_RESET';
export const FLOWDESIGNER_FLOW_ADD_ELEMENTS = 'FLOWDESIGNER.FLOW_ADD_ELEMENTS';
export const FLOWDESIGNER_FLOW_SET_ZOOM = 'FLOWDESIGNER.FLOW_SET_ZOOM';
export const FLOWDESIGNER_FLOW_ZOOM_IN = 'FLOWDESIGNER.FLOW_ZOOM_IN';
export const FLOWDESIGNER_FLOW_ZOOM_OUT = 'FLOWDESIGNER.FLOW_ZOOM_OUT';
export const FLOWDESIGNER_PAN_TO = 'FLOWDESIGNER_PAN_TO';

export const FLOWDESIGNER_NODE_ADD = 'FLOWDESIGNER_NODE_ADD';
export const FLOWDESIGNER_NODE_MOVE_START = 'FLOWDESIGNER_NODE_MOVE_START';
export const FLOWDESIGNER_NODE_MOVE = 'FLOWDESIGNER_NODE_MOVE';
export const FLOWDESIGNER_NODE_APPLY_MOVEMENT = 'FLOWDESIGNER_NODE_APPLY_MOVEMENT';
export const FLOWDESIGNER_NODE_MOVE_END = 'FLOWDESIGNER_NODE_MOVE_END';
export const FLOWDESIGNER_NODE_SET_SIZE = 'FLOWDESIGNER_NODE_SET_SIZE';
export const FLOWDESIGNER_NODE_SET_TYPE = 'FLOWDESIGNER_NODE_SET_TYPE';
export const FLOWDESIGNER_NODE_SET_GRAPHICAL_ATTRIBUTES =
	'FLOWDESIGNER_NODE_SET_GRAPHICAL_ATTRIBUTES';
export const FLOWDESIGNER_NODE_REMOVE_GRAPHICAL_ATTRIBUTES =
	'FLOWDESIGNER_NODE_REMOVE_GRAPHICAL_ATTRIBUTES';
export const FLOWDESIGNER_NODE_SET_DATA = 'FLOWDESIGNER_NODE_SET_DATA';
export const FLOWDESIGNER_NODE_REMOVE_DATA = 'FLOWDESIGNER_NODE_REMOVE_DATA';
export const FLOWDESIGNER_NODE_REMOVE = 'FLOWDESIGNER_NODE_REMOVE';
export const FLOWDESIGNER_NODE_UPDATE = 'FLOWDESIGNER_NODE_UPDATE';

export const FLOWDESIGNER_NODETYPE_SET = 'FLOWDESIGNER_NODETYPE_SET';

export const FLOWDESIGNER_PORT_ADD = 'FLOWDESIGNER_PORT_ADD';
export const FLOWDESIGNER_PORT_ADDS = 'FLOWDESIGNER_PORT_ADDS';
export const FLOWDESIGNER_PORT_SET_GRAPHICAL_ATTRIBUTES =
	'FLOWDESIGNER_PORT_SET_GRAPHICAL_ATTRIBUTES';
export const FLOWDESIGNER_PORT_REMOVE_GRAPHICAL_ATTRIBUTES =
	'FLOWDESIGNER_PORT_REMOVE_GRAPHICAL_ATTRIBUTES';
export const FLOWDESIGNER_PORT_SET_DATA = 'FLOWDESIGNER_PORT_SET_DATA';
export const FLOWDESIGNER_PORT_REMOVE_DATA = 'FLOWDESIGNER_PORT_REMOVE_DATA';
export const FLOWDESIGNER_PORT_REMOVE = 'FLOWDESIGNER_PORT_REMOVE';

export const FLOWDESIGNER_LINK_ADD = 'FLOWDESIGNER_LINK_ADD';
export const FLOWDESIGNER_LINK_SET_TARGET = 'FLOWDESIGNER_LINK_SET_TARGET';
export const FLOWDESIGNER_LINK_SET_SOURCE = 'FLOWDESIGNER_LINK_SET_SOURCE';
export const FLOWDESIGNER_LINK_REMOVE = 'FLOWDESIGNER_LINK_REMOVE';
export const FLOWDESIGNER_LINK_SET_GRAPHICAL_ATTRIBUTES =
	'FLOWDESIGNER_LINK_SET_GRAPHICAL_ATTRIBUTES';
export const FLOWDESIGNER_LINK_REMOVE_GRAPHICAL_ATTRIBUTES =
	'FLOWDESIGNER_LINK_REMOVE_GRAPHICAL_ATTRIBUTES';
export const FLOWDESIGNER_LINK_SET_DATA = 'FLOWDESIGNER_LINK_SET_DATA';
export const FLOWDESIGNER_LINK_REMOVE_DATA = 'FLOWDESIGNER_LINK_REMOVE_DATA';

export const PORT_SOURCE = 'OUTGOING';
export const PORT_SINK = 'INCOMING';

export const GRID_SIZE = 40;
